import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import DateField from '../../../../sharedComponents/DateField/DateField';
import { getSubmissionDates, getFirstSubmissionDate } from '../../../../states/calendar/selectors';
import { dateFormat } from '../../../../config/';

const mapState = (state) => ({
	submissionDates: getSubmissionDates(state),
	firstSubmissionDate: getFirstSubmissionDate(state),
});

class SubmissionDate extends Component {
	constructor(props) {
		super(props);
		this.handleBlur = this.handleBlur.bind(this);
	}
	handleBlur() {
		const { date, handleDateChange, firstSubmissionDate } = this.props;
		return handleDateChange(date || firstSubmissionDate);
	}
	render() {
		const { handleDateChange, date, inputWrapClassName, submissionDates } = this.props;

		return (
			<div className={inputWrapClassName}>
				<DateField
					id="field-submission-date"
					dateFormat={dateFormat}
					className="c-o-list-payment__input-with-fix"
					onChange={handleDateChange}
					onBlur={this.handleBlur}
					includeDates={submissionDates}
					selectedDate={date || ''}
				/>
			</div>
		);
	}
}

SubmissionDate.propTypes = {
	handleDateChange: PropTypes.func.isRequired,
	date: PropTypes.instanceOf(moment).isRequired,
	inputWrapClassName: PropTypes.string,
	submissionDates: PropTypes.arrayOf(PropTypes.shape({})),
	firstSubmissionDate: PropTypes.instanceOf(moment).isRequired,
};
export { SubmissionDate };
export default connect(mapState)(SubmissionDate);
